export default __webpack_public_path__ + "static/media/Japan.efff3194.svg";